import React from "react";
import "./Home.css";

export const Tutorials = () => {
  return (
    <div className="page-layout">
      <div className="text-layout">
        <h2>Tutorials</h2>
        <p>We have two tutorials this year. Details are as follows:</p>
        <h3>Tutorial 1: Deploying Smart Sensors for Human Subjects Research</h3>
        <h4>
          Room 1.10, Western Gateway Building, UCC - 15:30 to 17:00, Tuesday
          17th June 2025
        </h4>
        <h5>Abstract</h5>
        <p>
          Passive sensing systems—such as those using smartphones and
          smartwatches—allow for the real-time collection of physiological and
          behavioural data. These widely used devices offer a powerful
          opportunity to better understand human behaviour and health. The data
          collected through such systems can support a wide range of research
          areas, including the study of mental health. However, there is still a
          need to develop systems that can reliably and efficiently collect this
          data to enable deeper insights and support impactful applications,
          such as just-in-time adaptive interventions (JITAIs).
        </p>

        <h5
          style={{
            marginTop: "10px",
            marginBottom: "0px",
            fontStyle: "italic",
          }}
        >
          Md Sabbir Ahmed, University of Virginia, USA{" "}
        </h5>
        <h5
          style={{
            marginTop: "0px",
            marginBottom: "0px",
            fontStyle: "italic",
          }}
        >
          Mark Rucker, University of Virginia, USA
        </h5>
        <h5
          style={{
            marginTop: "0px",
            fontStyle: "italic",
          }}
        >
          Laura Barnes, University of Virginia, USA{" "}
        </h5>
        <h5>Description</h5>
        <p>
          In this tutorial, we will cover how to build a system that collects
          real-time sensing data directly from edge devices like smartphones and
          smartwatches. We will also walk through methods for pre-processing
          this data to extract meaningful bio-behavioural markers. Following
          that, we will discuss how to design and deploy AI models that can run
          efficiently on resource-constrained edge devices. The tutorial will
          also include strategies for enabling online learning on these devices,
          allowing models to adapt to new data over time. Finally, we will
          introduce our digital infrastructure built to support human-subjects
          research, which is flexible enough to be used across various research
          domains
        </p>
        <hr style={{ paddingBottom: "5px" }} />
        <h3>
          Tutorial 2: Secure & Smart Distributed Computing with Blockchain,
          Agentic AI AND LoRaWAN
        </h3>
        <h4>
          Room 1.10, Western Gateway Building, UCC - 11:00 to 12:30, Thursday
          19th June 2025
        </h4>
        <h5>Abstract</h5>
        <p>
          Distributed networks are among the most challenging and diverse
          research areas for real-time and non-real-time applications. It
          includes components ranging from the physical layer to the application
          layer. There are several security concerns which impact both the
          scalability and performance of distributed networks, which can be
          tackled using distributed secure computing methods such as exploring
          the use of blockchains, deploying agentic AI and leveraging long-range
          wide area network protocol, which also offers a low-power solution. In
          this tutorial, we aim to delve into the individual aspects of
          blockchains, agentic AI, and LoRaWAN, and explore how these
          technologies can come together to support distributed networks without
          compromising security. The tutorial has practical examples of each of
          the individual pillars, with discussions on bringing these together
          with several future challenges.
        </p>
        <h4>
          Tutorial 2(a): Secure & Smart Distributed Computing (Agentic AI &
          Blockchain)
        </h4>
        <h5
          style={{
            marginTop: "10px",
            marginBottom: "0px",
            fontStyle: "italic",
          }}
        >
          Vishal Sharma, Queen's University Belfast, UK
        </h5>
        <h5
          style={{
            marginTop: "0px",
            marginBottom: "0px",
            fontStyle: "italic",
          }}
        >
          Gyan Wickremasinghe, Queen's University Belfast, UK
        </h5>
        <h5
          style={{
            marginTop: "0px",
            marginBottom: "0px",
            fontStyle: "italic",
          }}
        >
          Oluwafemi Olukoya, Queen's University Belfast, UK
        </h5>
        <h5
          style={{
            marginTop: "0px",
            fontStyle: "italic",
          }}
        >
          Ayesha Abdul Majeed, Queen's University Belfast, UK
        </h5>
        <h5>Description</h5>
        <p>
          In tutorial 2 (a), Vishal, Gyan, Oluwafemi and Ayesha will lead a
          tutorial on Agentic AI and Blockchain. In particular, the team will
          focus on multi-agent orchestration and tokenisation and will help
          develop some basic applications, followed by research discussions.
        </p>
        <h4>
          Tutorial 2(b): Secure & Smart Distributed Computing (LoRaWAN –
          Practical Applications & EU Research)
        </h4>
        <h5
          style={{
            marginTop: "10px",
            marginBottom: "0px",
            fontStyle: "italic",
          }}
        >
          Trung Q. Duong , Memorial University of Newfoundland, Canada{" "}
        </h5>
        <h5
          style={{
            marginTop: "0px",
            marginBottom: "0px",
            fontStyle: "italic",
          }}
        >
          Vishal Sharma, Queen's University Belfast, UK
        </h5>
        <h5
          style={{
            marginTop: "0px",
            fontStyle: "italic",
          }}
        >
          Fannya Ratana Sandjaja, Queen's University Belfast, UK{" "}
        </h5>

        <h5>Description</h5>
        <p>
          In tutorial 2(b), Trung, Vishal, and Fannya will talk about the
          LoRaWAN from a practical point of view and demonstrate how they have
          utilised the technology in one of their EU-funded projects to measure
          harmful gases in the Arctic region. Each session is planned with an
          example or a case study, which would let the audience understand the
          practical implications and ask questions. Our tutorial is planned for
          an audience of intermediaries and experts. Thus, our tutorial is
          intended towards: 
        </p>
        <ul>
          <li>
            Blockchain researchers: Those interested in understanding the
            current landscape of secure and distributed computing from the
            perspective of blockchain, agentic AI and LoRaWAN. The tutorial
            tackles the physical to application layers of problems, which makes
            it unique if researchers want to explore unique research problems.{" "}
          </li>
          <li>
            Agentic AI enthusiasts: Those interested in the use cases of agentic
            AI and how this is reshaping the future deployment of applications
            will find it useful, in particular, they will understand how MVC can
            be used for implementing multi-agents and how it relates to
            multi-threaded applications.{" "}
          </li>
          <li>
            Startups and Innovators: Those interested in utilising blockchains
            and agentic AI for supporting their current ideas or looking for
            other verticals will find it interesting to understand both the pros
            and cons of the technology.{" "}
          </li>
          <li>
            Low-cost hardware enthusiasts: We will discuss practical limitations
            of the LoRaWAN technology and pose further challenges due to
            hardware limitations, which can be an interesting point for the
            hardware-driven network researchers.{" "}
          </li>
          <li>
            Security and malware: For those with core interest in applied
            security, malware analysis with blockchains can help them understand
            how traceability of the codes can be explored for protecting
            networks against the vulnerabilities.{" "}
          </li>
        </ul>
      </div>
    </div>
  );
};
